/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Other_PagesInputs */

const en_footer_other_pages = /** @type {(inputs: Footer_Other_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All pages`)
};

/**
* | output |
* | --- |
* | "All pages" |
*
* @param {Footer_Other_PagesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_other_pages = /** @type {((inputs?: Footer_Other_PagesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Other_PagesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_other_pages(inputs)
});